import { useEffect, useState } from 'react';
import { descargarPdfPredeterminada } from '../services/apiService';

type Rutina = {
  id: string;
  nombre: string;
  duracion: number;
  fecha: string;
  usuario: { nombre: string };
};

export default function HistorialRutinas() {
  const [rutinas, setRutinas] = useState<Rutina[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const adminId = localStorage.getItem('id');
    if (!adminId) return;

    fetch(`http://localhost:5001/api/rutinas?adminId=${adminId}`)
      .then(res => res.json())
      .then(data => setRutinas(data))
      .catch(() => setError('❌ Error al cargar historial'));
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h2 className="text-3xl font-bold text-center mb-6">📚 Historial de Rutinas</h2>

      {error && <p className="text-red-600 text-center mb-4">{error}</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {rutinas.map((r) => (
          <div key={r.id} className="bg-white shadow rounded-lg p-4 border border-gray-300">
            <h3 className="text-xl font-semibold mb-1">{r.nombre}</h3>
            <p className="text-sm text-gray-700">
              <strong>Duración:</strong> {r.duracion} min<br />
              <strong>Fecha:</strong> {new Date(r.fecha).toLocaleDateString()}<br />
              <strong>Alumno:</strong> {r.usuario?.nombre || 'Sin nombre'}
            </p>
            <button
              onClick={() => descargarPdfPredeterminada(r.id)}
              className="mt-3 bg-blue-600 hover:bg-blue-700 text-white py-1 px-3 rounded"
            >
              Descargar PDF
            </button>
          </div>
        ))}
      </div>

      {rutinas.length === 0 && (
        <p className="mt-6 text-center text-gray-600">No hay rutinas registradas aún.</p>
      )}
    </div>
  );
}
